// Endereço absoluto de uma rota do portal, para os links que saem da aplicação
// e voltam por fora dela — e-mail de recuperação de senha, retorno do Stripe.
//
// `__BASE_PATH__` vale `'/'` quando o portal está na raiz. Concatenar direto
// gerava `https://dominio//resetar-senha`, que o router não reconhece e cai no
// 404 (P-47).
export function urlDoPortal(
  caminho: string,
  origem: string = window.location.origin,
  base: string = __BASE_PATH__,
): string {
  const prefixo = base.replace(/^\/*/, '/').replace(/\/+$/, '');
  return `${origem.replace(/\/+$/, '')}${prefixo}/${caminho.replace(/^\/+/, '')}`;
}
